export const SELLERBOX_WEB_MONTHLY_SUBSCRIPTION_NO = 24;
export const SELLERBOX_PLUS_SUBSCRIPTION_NO = SELLERBOX_WEB_MONTHLY_SUBSCRIPTION_NO;
export const SELLERBOX_PLUS_MONTHLY_AMOUNT = 15000;

export const getSellerboxPlusPaymentPolicy = (isAnySubscribed: boolean) => {
  const isPrePayment = !isAnySubscribed;
  return {
    subscriptionNo: SELLERBOX_PLUS_SUBSCRIPTION_NO,
    isPrePayment,
    paymentAmount: isPrePayment ? 0 : SELLERBOX_PLUS_MONTHLY_AMOUNT,
  };
};
